module.exports = __webpack_public_path__ + "img/routeChami .648d4f89.png";